<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="ModalDigest"
    title="Filter Landscapes"
    submit-name="Save"
    full-height
    :submit-disabled="!dataHasChanged"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-loading v-if="!landscapes" :size="32" blue />
    <template v-else>
      <p class="text-gray-700">
        You can select the Landscapes and first level Actors you want to be
        notified about.
      </p>
      <ul class="Digest-landscapes">
        <li
          v-for="landscape in landscapes"
          :key="landscape.slug"
          class="Landscape"
        >
          <header class="Landscape-header ItemList">
            <h1 class="Title">{{ landscape.name }}</h1>
            <lm-checkbox
              v-model="landscape.subscribed"
              @change="changeLandscapeAll(landscape)"
            />
          </header>
          <ul class="ActorList">
            <li
              v-for="actor in landscape.actors"
              :key="actor._id"
              class="Actor ItemList"
            >
              <h1 class="Title">{{ actor.name }}</h1>
              <lm-checkbox
                v-model="actor.subscribed"
                @change="changeLandscape(landscape, actor.subscribed)"
              />
            </li>
          </ul>
        </li>
      </ul>
    </template>
  </form-modal>
</template>

<script>
import LmCheckbox from '@/components/form/LmCheckbox'
import LmLoading from '@/components/ui/LmLoading'
import {Modal} from '@/lib/definitions'
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'

export default {
  name: 'ModalDigest',
  components: {
    LmCheckbox,
    LmLoading,
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.DIGEST,
      modalRef: null,
      landscapes: null,
      dataHasChanged: false
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('getDigest').then(res => {
        this.landscapes = res
      })
    },
    submit() {
      this.$store
        .dispatch('saveDigest', this.landscapes)
        .then(() => this.modalRef.submitSuccess())
        .catch(error => this.modalRef.submitFails(error))
    },
    changeLandscape(landscape, subscribed) {
      this.dataHasChanged = true
      if (!subscribed) {
        landscape.subscribed = false
        return
      }
      landscape.subscribed = landscape.actors.every(actor => actor.subscribed)
    },
    changeLandscapeAll(landscape) {
      this.dataHasChanged = true
      landscape.actors.forEach(actor => {
        actor.subscribed = landscape.subscribed
      })
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'Preferences updated')
      }
    }
  }
}
</script>

<style>
.ModalDigest {
  .ui-checkbox {
    margin-bottom: 0;
  }
}
</style>
<style scoped>
.ModalDigest {
  ul {
    margin: 0;
    padding: 0;
  }
  .Digest-landscapes {
    margin-top: 30px;
    .Title {
      margin: 0;
      line-height: 1.4;
      font-size: 14px;
      text-transform: uppercase;
    }
    .Landscape {
      margin-bottom: 30px;
      border-top: 1px solid #eaeaea;
      .ItemList {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      &-header {
        margin-top: 30px;
        margin-bottom: 10px;
      }
      .Actor {
        border-bottom: 1px dashed #eaeaea;
        padding: 10px 0;
        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }
        .Title {
          color: #555;
          text-transform: capitalize;
        }
      }
    }
  }
}
</style>
